import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { REGION_REPORT_ID } from './regionReportId';

const emptyColumns = [FIELDS.REGION_CODE].map(createFooterMapper(REGION_REPORT_ID));

const regionReportFooterColumnDefinition = [...emptyColumns];

export default regionReportFooterColumnDefinition;
